
import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { useState, Downgraded } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import
    {
        Box, Card,
        CardContent,
        Typography,
        Checkbox
    } from '@mui/material';
import Helper from '../../utility/helper';
// import CircularProgress from '@mui/material/CircularProgress';

// const loader = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100%',
//     width: '100%',
// };
const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        // [theme.breakpoints.only('xs')]: {
        //     flexFlow: 'column wrap',
        //     flexDirection: 'column',
        // },
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
    },
    columnContent: {
        display: 'flex',
        // justifyContent: 'flex-start',
        alignItems: 'center',
        // this logic needs to be handle for mobile view
        [theme.breakpoints.only('xs')]: {
            flexBasis: '33%',
        },
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary'
    },
}));


const SyncParticipant = (props) =>
{

    //const userRole = useState(null);
    const userInfo = useState()
    const selectedTags = useState([]);
    const syncParticipantsInfo = useState(null);
    //const userStatus = useState(1);
    const classes = useStyles();
    const isLoading = useState(false);
    const commonTags = useState();
    const allCheckSelect = useState(false);
    const eventInfo = useState(null)
    const activityTags = useState([])

    useEffect(() =>
    {
        const guserInfo = Helper.getStorage('userInfo');
        const geventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        eventInfo.set(geventInfo);
        syncParticipantsInfo.set(props.syncParticipantsInfo);
        getActivityTags(geventInfo.eventID)

    }, []);

    const getActivityTags = (eventId) =>
    {
        //if (eventInfo) {
        ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_LIST_TAG(eventId)
        ).then(res =>
        {
            let arr = res.data;
            activityTags.set(arr);
        }).catch(err =>
        {
            console.log(err);
        })
        //}
    }

    // const setRolesNTags = async (eventID) =>
    // {
    //     const rolesdata = ApiHelper.get(APIURLConstants.GET_ROLES(eventID));
    //     const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));

    //     await Promise.all([rolesdata, tagsdata]).then((data) =>
    //     {

    //         Helper.setStorage('userRoles', data[0].data);
    //         Helper.setStorage('userTags', data[1].data);
    //         const rolesd = data[0].data.filter((item) => item.status == 1);
    //         const tagsd = data[1].data.filter((item) => item.status == 1);
    //         tags.set(tagsd);
    //         roles.set(rolesd);
    //     });
    // };
    const onCheckSelect = (event, userId, tagId) =>
    {
        let newFilterList = selectedTags.attach(Downgraded).get();
        if (event.target.checked)
        {
            //check if user Exist in selected List
            if (newFilterList.findIndex(x => x.userID === userId) > -1)
            {
                let index = newFilterList.findIndex(x => x.userID === userId)
                let obj = newFilterList[index];
                obj.tagId = [...obj.tagId, tagId];

                newFilterList[index] = obj;
            } else
            {
                let obj = { userID: userId, createdBy: userInfo.attach(Downgraded).get().userID, tagId: [tagId] }
                newFilterList.push(obj);
            }
            selectedTags.set(newFilterList);
            let totalCount = 0;
            newFilterList.forEach(x =>
            {
                totalCount = totalCount + x.tagId.length
            })
            if (totalCount === commonTags.get())
            {
                allCheckSelect.set(true);
            } else
            {
                allCheckSelect.set(false);
            }
        } else
        {
            //remove the id from selected list
            allCheckSelect.set(false);
            let index = newFilterList.findIndex(x => x.userID === userId);
            let obj = newFilterList[index];
            let tagIndex = obj.tagId.indexOf(tagId);
            obj.tagId.splice(tagIndex, 1);
            if (obj.tagId.length === 0)
            {
                newFilterList.splice(index, 1);
            }

            selectedTags.set(newFilterList);
            let totalCount = 0;
            newFilterList.forEach(x =>
            {
                totalCount = totalCount + x.tagId.length
            })
            if (totalCount === commonTags.get())
            {
                allCheckSelect.set(true);
            } else
            {
                allCheckSelect.set(false);
            }
        }
    }

    const renderDialogContent = () =>
    {

        let totalCommonTags = 0;
        return <>
            {props.syncParticipantsInfo.length > 0 ?
                <>
                    {props.syncParticipantsInfo.map((item, key) =>
                    {
                        let userTags = item.actualData.userTags !== null ? item.actualData.userTags.split(', ').map(x => x.trim()) : [];
                        let tags = activityTags.attach(Downgraded).get();
                        let filterTags = tags.filter(x => userTags.includes(x.tagName));
                        totalCommonTags = totalCommonTags + filterTags.length;
                        let tagsChecked = selectedTags.attach(Downgraded).get().find(x => x.userID === item.actualData.userID)?.tagId ?? []
                        return <Card key={key}
                            classes={{ root: classes.paperContent }}
                            sx={{ width: '100%', mb: 2 }}>
                            <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                                <Box className={classes.rowContent}>
                                    <Box className={classes.columnContent} component='div' sx={{ flex: '0.3' }} >

                                        <Typography>{item.actualData.name}</Typography>

                                    </Box>
                                    <Box component='div' className={classes.columnContent} sx={{ display: 'flex', flex: '0.8', flexWrap: 'wrap' }}>
                                        {filterTags && filterTags.length > 0 && filterTags.map((tag, index) =>
                                        {

                                            return <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Checkbox
                                                    inputProps={{
                                                        'aria-label': 'ActivityTags',
                                                    }}
                                                    size="small"
                                                    checked={tagsChecked.includes(tag.tagID)}
                                                    onChange={(event) => onCheckSelect(event, item.actualData.userID, tag.tagID)}
                                                    // color="secondary"
                                                    value={tag.tagName}

                                                />
                                                <Typography>{tag.tagName}</Typography>
                                            </Box>

                                        })}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    })}
                    {
                        commonTags.set(totalCommonTags)
                    }
                </>
                : null}


        </>

    };

    const handleClick = () =>
    {
        if (selectedTags.attach(Downgraded).get().length > 0)
        {
            isLoading.set(true);
            ApiHelper.post(APIURLConstants.SYNC_ACTIVITY_PARTICIPANTS(eventInfo.attach(Downgraded).get().eventID), selectedTags.attach(Downgraded).get())
                .then((res) =>
                {
                    if (res.data)
                    {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participant sync successfully to selected activity tags.',
                        });
                        props.handleClose();
                        props.getParticipants();
                    }
                })
                .catch((error) =>
                {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401)
                    {
                        message = 'Access denied';
                    } else
                    {
                        message = 'Error while syncing participant to selected activity tags.';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    props.handleClose();
                    //props.getParticipants();
                });
        } else
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'warning',
                message: 'Please select at least one participant tag.',
            });
        }
    };

    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                showLoading={true}
                loading={isLoading.get()}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Sync'}
            />
        );
    };
    const handleAllCheckSelect = (e) =>
    {
        // allCheckSelect.set(select => !select)
        if (e.target.checked)
        {
            let overallTags = [];
            let overalltagCount = 0
            props.syncParticipantsInfo.forEach(participant =>
            {
                let userTags = participant.actualData.userTags !== null ? participant.actualData.userTags.split(', ').map(x => x.trim()) : [];
                let tags = activityTags.attach(Downgraded).get();
                let filterTags = tags.filter(x => userTags.includes(x.tagName));
                ///filterTags.forEach(userTags => {
                let count = filterTags.map(x => x.tagID).length;
                overalltagCount = overalltagCount + count;


                let obj = { userID: participant.actualData.userID, createdBy: userInfo.attach(Downgraded).get().userID, tagId: filterTags.map(x => x.tagID) }
                if (obj.tagId.length > 0)
                {
                    overallTags.push(obj);
                }


                //});
            });
            allCheckSelect.set(true)
            selectedTags.set(overallTags)
            commonTags.set(overalltagCount);
        } else
        {
            selectedTags.set([])
            allCheckSelect.set(false)
            commonTags.set();
        }

    }
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            showCheckBox={true}
            selected={allCheckSelect.get()}
            onCheckSelect={handleAllCheckSelect}
            // maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default SyncParticipant;
